var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panel-header',[_c('span',{staticStyle:{"font-size":"1.2rem"}},[_c('v-icon',{staticStyle:{"margin-right":"10px"},attrs:{"size":"30","color":_vm.icon_color}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_c('b',{staticStyle:{"position":"relative","top":"3px"}},[_vm._v(" "+_vm._s(_vm.label)+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }